import { HugeiconsIcon } from '@hugeicons/react'
import { ArrowDown01Icon } from '@hugeicons-pro/core-stroke-rounded'
import { Accordion, AccordionDetails, AccordionSummary, Box, Typography } from '@mui/material'
import PropTypes from 'prop-types'

const classes = {
    AccordionRoot: {
        borderTop: () => '1px solid hsl(0, 0%, 35%)',
        backgroundColor: 'background.default',
        '&:before': {
            display: 'none',
        },
        '&:last-of-type': {
            borderBottom: () => '1px solid hsl(0, 0%, 35%)',
        },
    },
    AccordionSummary: {
        backgroundColor: 'hsl(0, 0%, 15%)',
        '& .MuiAccordionSummary-content': {
            justifyContent: 'space-between',
            margin: '12px 0',
            '&.Mui-expanded': {
                margin: '12px 0',
            },
        },
    },

    AccordionDetails: {
        backgroundColor: 'hsl(0, 0%, 15%)',
        padding: '0 16px 16px',
    },
}
const DrawerItem = ({ children, drawerOpen, editButton = null, handleOpenDrawer, icon, title }) => {
    return (
        <Accordion
            defaultExpanded={true}
            elevation={0}
            sx={classes.AccordionRoot}
            disableGutters
            square
            onChange={handleOpenDrawer}
        >
            <AccordionSummary
                aria-controls={title + '-content'}
                expandIcon={
                    drawerOpen ? (
                        <HugeiconsIcon
                            icon={ArrowDown01Icon}
                            size={20}
                        />
                    ) : null
                }
                id={title + '-accordion'}
                sx={classes.AccordionSummary}
            >
                <Box
                    sx={{
                        alignItems: 'center',
                        display: 'flex',
                        flexDirection: 'row',
                    }}
                >
                    {icon}
                    <Box>
                        {drawerOpen ? (
                            <Box
                                sx={{
                                    alignItems: 'center',
                                    display: 'flex',
                                    flexDirection: 'row',
                                    justifyContent: 'space-between',
                                    gap: 1,
                                    margin: 1,
                                }}
                            >
                                <Box>
                                    <Typography>{title}</Typography>
                                </Box>
                                {editButton ? <Box>{editButton}</Box> : null}
                            </Box>
                        ) : null}
                    </Box>
                </Box>
            </AccordionSummary>
            {drawerOpen ? (
                <AccordionDetails sx={classes.AccordionDetails}>
                    <Box
                        sx={{
                            display: 'flex',
                            flexDirection: 'column',
                        }}
                    >
                        {children}
                    </Box>
                </AccordionDetails>
            ) : null}
        </Accordion>
    )
}

DrawerItem.propTypes = {
    children: PropTypes.element,
    drawerOpen: PropTypes.bool,
    editButton: PropTypes.any,
    handleOpenDrawer: PropTypes.func,
    icon: PropTypes.element,
    title: PropTypes.string,
}

export default DrawerItem
